//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'AnoFiscal',
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast.create(this.$t('message.acesso_negado'), 'snack', 3E3);
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ANO_FISCAL').length;
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/ano-fiscal/AnoFiscal.vue?vue&type=script&lang=js&